












































import { JobTake5Check } from '@/models/jobTake5/jobTake5Check';
import Nullable from '@/types/nullable';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class Take5Controls extends Vue {
  @Prop({ type: Object, default: null }) public take5!: Nullable<JobTake5Check>;

  private expanded: boolean = false;

  get showSafetyAlert() {

    for(var i = 0; i < this.take5.hazards.length; i++){
      if(this.take5.hazards[i].control_effective == false){
        return true;
      }
    }
    return false
  }

  textRequired(v: string) {
    if (v == null || v.length == 0) {
      return "Cannot be left blank";
    }

    return true;
  }
}

